import {Component} from "react";
import SliderPanel from "../BaseLayout/SliderPanel.mjs";
import TextLabel from "../../controls/TextLabel/TextLabel.mjs";
import Glob from "../../libs/Glob.mjs";
import "./SynthGen.css";
import AppSynthGenIcon from "../../media/app-images/AppSynthGenIcon.mjs";
import AppPerimeterIcon from "../../media/app-images/AppPerimeterIcon.mjs";
import appLib from "../../libs/appLib.mjs";

const prefix = "SynthGen";

const SynthGen = class extends Component {
	constructor(props) {
		super(props);
		this.state = { ul: Glob.getStatus('userLogin') }
		this.loader = this.loader.bind(this);
		this.uid = Glob.generateUid(prefix);
	}
	loader() {
		const ul = this.state.ul;
		this.setState({ auth: ul ? encodeURIComponent(JSON.stringify({params:{username:ul.username,session:ul.session}})) : false });
	}
	componentDidMount() {
		Glob.setStatus('pageTitle', ["Perimeters","Synthetic data generator"]);
		Glob.setStatus('pageIcon', <AppPerimeterIcon />);
		Glob.register( 'userLogin', userLogin => {
			this.setState({ ul: userLogin }, this.loader);
		}, this.uid);
		this.loader();
	}
	componentWillUnmount() {
		Glob.unregister('userLogin', this.uid);
	}
	render() {
		if ( ! this.state.auth ) return null;
		return (
			<SliderPanel
				full={true}
				title={<TextLabel value={"Synthetic data generator"}/>}
				icon={<AppSynthGenIcon />}
				className={prefix}
			>
				<iframe
					title={ Glob.label("Synthetic data generator")}
					src={`/psncgen/?auth=${this.state.auth}&canEdit=${appLib.enabled()}`}
					id={this.uid}
					height={"100%"}
					width={"100%"}
				/>
			</SliderPanel>
		)
	}
}

export default SynthGen;